import { useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { accountabilityExpenseService } from "~/application/usecases";
import { snackbarService } from "~/components/SnackbarStack";
import { QueryTimes } from "~/constants";
import { LOG_TAG } from "~/presentation/shared/components/TabOrderMessages/types";
import { logError } from "~/presentation/shared/utils/errors";
import { log } from "~/utils/log";

export const useVoucherGallery = () => {
  const { data: vouchersGallery, isLoading: isLoadingVoucherGalery } = useQuery(
    ["VouchersGallery"],
    async () => await accountabilityExpenseService.getVouchersList(),
    {
      staleTime: QueryTimes.SMALLEST,
      refetchOnMount: "always",
      onError: (error) => {
        logError({
          logTag: LOG_TAG,
          error,
          defaultErrorMessage: "Failed to load vouchers gallery",
        });
      },
    }
  );

  return {
    vouchersGallery,
    isLoadingVoucherGalery,
  };
};
